import React, { useRef, useState } from 'react';
import { appActions } from '../../state/modules/app';
import { useDispatch } from 'react-redux';
import { InfoButton } from './Button';
import { ResourceType } from '../../graphql/schema/p4types';

type UploadResponse = {
  response: {
    filename: string;
  };
};

const ZipImageSelector = ({
  resourceType,
  onUploadSuccess,
}: {
  resourceType: ResourceType;
  onUploadSuccess?: (fileName: string) => void;
}) => {
  const zipSelectorRef = useRef<HTMLInputElement>(null);
  const [newFileName, setNewFileName] = useState('');
  const dispatch = useDispatch();

  const handleImageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const files = event.target?.files;

    if (files) {
      handleFilesUpload(files[0]);
    }
  };

  const handleZipUploadSuccess = ({ response }: UploadResponse) => {
    if (onUploadSuccess) {
      setNewFileName(response.filename);
      onUploadSuccess(response.filename);
    }
  };

  const handleFilesUpload = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    Promise.resolve(dispatch(appActions.uploadFile(formData, `resources/${resourceType}/upload`, null))).then((tbd) => {
      handleZipUploadSuccess(tbd as unknown as UploadResponse);
    });
  };

  const uploadClick = () => {
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: false,
      cancelable: false,
    });
    zipSelectorRef.current?.dispatchEvent(clickEvent);
  };

  return (
    <div>
      <div style={{ padding: '5px 0' }}>
        <input
          name="file"
          type="file"
          onChange={handleImageSelect}
          style={{ display: 'none' }}
          ref={zipSelectorRef}
          accept="application/zip"
          multiple={false}
        />
        <InfoButton onClick={uploadClick}>Upload ZIP File</InfoButton>
      </div>
      {newFileName && <p style={{ padding: '5px 0' }}>Successfully Uploaded: {newFileName}</p>}
    </div>
  );
};

export default ZipImageSelector;
